import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

//引入echart
//4.x 引用方式
import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

// 全局拦截 jessibuca 播放器内部异步抛出的运行时错误，避免展厅大屏显示报错遮罩
const isPlayerNoiseError = (msg) => {
  if (!msg) return false;
  const text = String(msg);
  return text.includes("Cannot read properties of null") ||
         text.includes("clearView") ||
         text.includes("_opt") ||
         text.includes("jessibuca");
};

window.addEventListener('error', (event) => {
  const msg = event && (event.message || (event.error && event.error.message));
  if (isPlayerNoiseError(msg) || (event.filename && event.filename.includes('jessibuca'))) {
    event.preventDefault();
    event.stopImmediatePropagation();
    console.warn('[已忽略播放器内部错误]', msg);
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const msg = event && event.reason && (event.reason.message || event.reason);
  if (isPlayerNoiseError(msg)) {
    event.preventDefault();
    console.warn('[已忽略播放器内部Promise错误]', msg);
  }
});

// Vue 组件内错误处理，防止播放器错误冒泡
Vue.config.errorHandler = (err, vm, info) => {
  if (isPlayerNoiseError(err && err.message)) {
    console.warn('[已忽略播放器组件错误]', err && err.message, info);
    return;
  }
  console.error('Vue错误:', err, info);
};

// 全局注册
Vue.component('icon', Icon);
Vue.use(dataV);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
